import { InjectionToken } from '@angular/core';

/**
 * Injection token to pass parent form's rowGap to nested form widgets.
 * This allows child forms to inherit the gap configuration from their parent
 * form widget, limited to the current form instance only.
 */
export const PARENT_FORM_ROW_GAP = new InjectionToken<string | undefined>('PARENT_FORM_ROW_GAP');

/**
 * Injection token carrying the fully-resolved WorkflowFormsService path a Form Widget's own
 * fields were added to (only set when formsConfig.formType is 'group' | 'array'). Leaf widgets
 * that otherwise resolve their own target FormGroup from inputFieldConfig.parentForm (e.g.
 * InputFieldWidgetComponent, AddressWidgetComponent) only ever compute a plain root/page-scoped
 * path from that property - this token lets them bind to the actual nested group/array-item
 * path instead, without needing per-field RHS configuration.
 */
export const RESOLVED_FORM_GROUP_PATH = new InjectionToken<string | undefined>('RESOLVED_FORM_GROUP_PATH');
